export default __webpack_public_path__ + "static/media/Artboard9.4676073b.jpg";